module.exports = __webpack_public_path__ + "static/img/bg-ar.fd4f3926.png";